import { GenericObject } from 'core/models/platform';

export enum ActiveDialogOnPageEnum {
  NO_DIALOG = 'NO_DIALOG',
  ONBOARDING_DIALOG = 'ONBOARDING_DIALOG',
  OPEN_PROJECTS_DIALOG = 'OPEN_PROJECTS_DIALOG',
  LOADING_DIALOG = 'LOADING_DIALOG',
  CREATING_DIALOG = 'CREATING_DIALOG',
  RESTORING_DIALOG = 'RESTORING_DIALOG',
  PREMIUM_UPSEL_DIALOG = 'PREMIUM_UPSEL_DIALOG',
  MOVE_TO_TRASH_DIALOG = 'MOVE_TO_TRASH_DIALOG',
  COPY_DIALOG = 'COPY_DIALOG',
}

export interface ActiveDialogState {
  dialog: ActiveDialogOnPageEnum;
  props: GenericObject | null;
}
